export const FORECASTING_CHANNEL_COLORS = [
  "#0079c1",
  "#AD343E",
  "#F2AF29",
  "#7D3AC1",
  "#628B48",
  "#FF3CC7",
  "#00E5E8",
  "#FF5733",
  "#4A90E2",
  "#50B74A",
  "#F5A623",
  "#D0021B",
  "#9013FE",
  "#B8E986",
  "#4A4A4A",
  "#F8E71C",
  "#8B572A",
  "#417505",
  "#BD10E0",
  "#F9A8E3",
  "#001F3F",
  "#FF851B",
  "#85144B",
  "#39CCCC",
  "#3D9970",
  "#FFDC00",
  "#B10DC9",
  "#FF4136",
  "#2ECC40",
  "#FF69B4",
  "#1F618D",
];

export const FORECASTING_CHANNEL_COLOR_BY_NAME = {
  ooh: "#0079c1",
  programmatic: "#AD343E",
  radio: "#F2AF29",
  tv: "#7D3AC1",
  social: "#628B48",
  youtube: "#4A90E2",
  search: "#50B74A",
  performance_max: "#F5A623",
};

const RESERVED_FORECASTING_CHANNEL_COLORS = new Set(
  Object.values(FORECASTING_CHANNEL_COLOR_BY_NAME)
);

const FORECASTING_CHANNEL_FALLBACK_COLORS = FORECASTING_CHANNEL_COLORS.filter(
  (color) => {
    return !RESERVED_FORECASTING_CHANNEL_COLORS.has(color);
  }
);

export function normalizeForecastingChannelName(channel) {
  return String(channel || "")
    .trim()
    .toLowerCase();
}

export function getForecastingChannelColor(channel, index) {
  const normalizedChannel = normalizeForecastingChannelName(channel);

  if (
    normalizedChannel &&
    Object.prototype.hasOwnProperty.call(
      FORECASTING_CHANNEL_COLOR_BY_NAME,
      normalizedChannel
    )
  ) {
    return FORECASTING_CHANNEL_COLOR_BY_NAME[normalizedChannel];
  }

  return FORECASTING_CHANNEL_FALLBACK_COLORS[
    index % FORECASTING_CHANNEL_FALLBACK_COLORS.length
  ];
}

export function buildForecastingChannelColorMap(channels) {
  const channelColors = {};

  channels.forEach((channel, idx) => {
    if (channel == null || channel === "") {
      return;
    }

    const color = getForecastingChannelColor(channel, idx);
    channelColors[channel] = color;
    channelColors[normalizeForecastingChannelName(channel)] = color;
  });

  return channelColors;
}
